import { colors, styled } from 'core/styles';

export const TagBox = styled('span')(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0 6px',
  lineHeight: 1,
  height: 'calc(4px + 1em)',
  minWidth: '2.8em',
  borderRadius: 'calc((4px + 1em) / 2)',
  backgroundColor: colors.blackOpacity[12],
}));
